import React from "react";
import Showjob from "./Showjob";
import Industrynav from "./Industrynav";



export default function Industryhome() {
  return (
    <>
     <Industrynav/>
     <Showjob/>
    
    </>
  );
}
